import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/workflowDefinitionVersion'
import { localized } from '@/decorators/localized'
import { formatDate, defaultDateTimeFormat } from '@/utils/dateUtilities'
import { Row, Col, Label } from 'reactstrap'
import { Main, MainTop, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import Resx from '@/components/Resx'
import getEnumTranslation from '@/enums/enums'
import { workflowDefinitionType } from '@/enums/workflowDefinitionType'
import LoadingIndicator from '@/components/LoadingIndicator'
import { decodeVersionString } from '@/utils/versionConverter'

@localized()
class WorkflowDefinitionVersionDetail extends React.Component {
  getId = () => this.props.match.params.id
  getParentId = () => this.props.match.params.parentId
  componentDidMount () {
    this.reload()
  }
  reload () {
    this.props.get(this.getId())
  }
  renderBody () {
    const { workflowDefinitionVersion, localize } = this.props
    if (workflowDefinitionVersion.fetching === true || workflowDefinitionVersion.workflowDefinitionVersion === null) { return <LoadingIndicator /> }
    const enumName = workflowDefinitionType.enumName
    const entity = workflowDefinitionVersion.workflowDefinitionVersion
    return (
      <React.Fragment>
        <WhiteBox>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Code' />: </Label>
              <span className='ml-2'>{entity.code}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.AllowManualExecution' />: </Label>
              <span className='ml-2'>{entity.allowManualExecution === true ? <Resx name='Common.Yes' /> : <Resx name='Common.No' />}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Version' />: </Label>
              <span className='ml-2'>{decodeVersionString(entity.version)}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Type' />: </Label>
              <span className='ml-2'>{getEnumTranslation({ localize, enumName, value: entity.workflowDefinitionType })}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.Name' />: </Label>
              <span className='ml-2'>{entity.name}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.LatinName' />: </Label>
              <span className='ml-2'>{entity.latinName}</span>
            </Col>
          </Row>
          <Row>
            <Col lg='6'>
              <Label><Resx name='Common.CreationTime' />: </Label>
              <span className='ml-2'>{formatDate(entity.creationTime, defaultDateTimeFormat)}</span>
            </Col>
          </Row>
        </WhiteBox>
        <WhiteBox header='Common.Definition'>
          <div><pre><code>{JSON.stringify(JSON.parse(entity.definition), null, 2)}</code></pre></div>
        </WhiteBox>
      </React.Fragment>
    )
  }
  render () {
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={`/workflow-configuration/${this.getParentId()}`}><Resx name='Common.WorkflowConfigurationVersion' /></MainTopTitle>
        </MainTop>
        <MainBody>
          {this.renderBody()}
        </MainBody>
      </Main>
    )
  }
}

function mapStateToProps (state) {
  return {
    workflowDefinitionVersion: state.workflowDefinitionVersion
  }
}

const mapDispatchToProps = {
  get: actionCreators.get
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkflowDefinitionVersionDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/workflow-configuration/version/detail.js